import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  iconRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 4
  },

  menuRoot: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 8px'
  },

  tabs: {
    marginBottom: '10px'
  },

  tab: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
